/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { NewRubricMappingItem } from './NewRubricMappingItem';
const CommunityLibaryItemImportResultParser = 
/* #__PURE__ */ parsers.object([
    [
        'rubricMapping',
        /* #__PURE__ */ codecArray(NewRubricMappingItem),
        'rubric_mapping',
    ],
]);
export class CommunityLibaryItemImportResult extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CommunityLibaryItemImportResultParser.decode(input).map(res => new CommunityLibaryItemImportResult(res));
    }
    static unsafeDecode(input) {
        return CommunityLibaryItemImportResult.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CommunityLibaryItemImportResultParser.encode(data);
    }
    static schema() {
        return CommunityLibaryItemImportResultParser.schema();
    }
}
